export { default as ShieldWarningIcon } from '~icons/mdi/shield-warning-outline';
